/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2019 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */
import React from "react";
import PropTypes from "prop-types";
import Modal from "react-modal";
import ProgressBar from '../../widgets/ProgressBar/ProgressBar';
Modal.setAppElement("#root");

export default class ModalDialog extends React.Component {
    static get propTypes() {
        return {
            title: PropTypes.string,
            errorMsg: PropTypes.string,
            showError: PropTypes.string,
            children: PropTypes.node.isRequired,
            showModal: PropTypes.bool.isRequired,
            onCancel: PropTypes.func,
            onSuccess: PropTypes.func,
            showCloseControls: PropTypes.bool,
            successText: PropTypes.string,
            cancelText: PropTypes.string,
            showSuccess: PropTypes.bool,
            showCancel: PropTypes.bool,
            showFooter: PropTypes.bool,
            disableSuccess: PropTypes.bool,
            showProgress: PropTypes.bool,
            progressPercentage: PropTypes.string,
            className: PropTypes.string
        };
    }

    static defaultProps = {
        showCloseControls: true,
        showSuccess: true,
        showCancel: true,
        showFooter: true,
        successText: "Save",
        cancelText: "Cancel",
        disableSuccess: false,
        className: ""
    };

    render() {
        const {title, showModal, onCancel } = this.props;
        const {children} = this.props;
        return (
            <div className="modal-dialog-widget">
                <Modal
                    className={`modal-content ${this.props.className}`}
                    overlayClassName="modal-overlay"
                    isOpen={showModal}
                    onRequestClose={onCancel}
                    contentLabel={title}
                    closeTimeoutMS={150}
                >
                    <div className="modal-header">
                        <h4>{this.props.title}</h4>
                        {this.props.showCloseControls && (
                            <div
                                className="modal-close-button"
                                onClick={this.props.onCancel}
                            >
                                <svg
                                    aria-hidden="true"
                                    focusable="false"
                                    className="pe-icon--remove-sm-24"
                                >
                                    <use xlinkHref="#remove-sm-24" />
                                </svg>
                            </div>
                        )}
                    </div>

                    <div className="modal-body">{children}</div>

                    {this.props.showFooter && (
                        <div className="modal-footer">
                            {this.props.showProgress && (
                                <ProgressBar min={0} max={100} value={this.props.progressPercentage}
                                    type="animated" alignLabel="left" id="cc-upload-progress-bar" />
                            )}
                            {this.props.showError && (
                                <label className="error-msg">{this.props.errorMsg}</label>
                            )}
                            {this.props.showCancel && (
                                <button
                                    className="pe-btn--btn_large"
                                    onClick={this.props.onCancel}
                                >
                                    {this.props.cancelText}
                                </button>
                            )}
                            {this.props.showSuccess && (
                                <button
                                    className="pe-btn__primary--btn_large"
                                    onClick={this.props.onSuccess}
                                    disabled = {this.props.disableSuccess}
                                >
                                    {this.props.successText}
                                </button>
                            )}
                        </div>
                    )}
                </Modal>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/widgets/ModalDialog/ModalDialog.js